import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

export default function PersonalDetails(props) {
  const [focused, setFocused] = useState(false);
  const [DOB, setDOB] = useState(new Date());
  const [anniv, setAnniv] = useState(new Date());

  return (
    <React.Fragment>
      <Container className="formBG" style={{ padding: "0" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
          variant="outlined"
          padding="0"
        >
          <Typography level="body1" style={{ padding: "0 1rem 2rem 1rem" }}>
            At AJ's Java Joint, We love celebrating Birthdays and
            Anniversaries. Please share your date below so we can celebrate with
            you. You can click submit anyways, without changing those fields.
          </Typography>

          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              sx={{ padding: "15px", width: "100%" }}
              label="Birthday(MM/dd) - Optional"
              format="MM/dd"
              value={props.DOB ? props.DOB : DOB}
              onChange={(date) => {
                props.getDOB(date);
                setDOB(date);
              }}
              slotProps={{
                textField: {
                  variant: "outlined",
                  style: { color: props.DOB == "" ? "#f5f5db" : "#000000" },
                },
              }}
            />

            <DatePicker
              sx={{ padding: "15px", width: "100%" }}
              label="Anniversary(MM/dd) - Optional"
              format="MM/dd"
              value={props.anniv ? props.anniv : anniv}
              onChange={(date) => {
                props.getAnniv(date);
                setAnniv(date);
              }}
              slotProps={{
                textField: {
                  variant: "outlined",
                  style: { color: props.anniv == "" ? "#f5f5db" : "#000000" },
                },
              }}
            />
          </LocalizationProvider>
        </Box>
      </Container>
    </React.Fragment>
  );
}
